<template>
    <button @click = "click" class = 'm-1 bg-green-700 hover:bg-green-900 rounded p-2 text-white text-sm' :class="class">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 inline-block" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" :d="svg" />
        </svg>
        <span class = 'hidden sm:inline-block ml-1'>{{ label }}</span>
    </button>
</template>

<script>
export default {
    name:"IconButtonGreen",
    props:{
        label:"",
        svg:"",
        class: ""
    },
    methods:{
        click:function(){
            this.$emit('click')
        }
    }
}
</script>